import { Stack, Grid, Typography } from "@mui/material";
import Title from "./Title";
import { useCallback, useState } from "react";
import ImageViewer from "react-simple-image-viewer";
interface IimageI {
  src: string;
  title: string;
}
type Props = {
  title?: string;
  paddingLeft: number;
  imagesArray: IimageI[];
  color?: string;
};

const ImgGallery = ({ title, paddingLeft, imagesArray, color }: Props) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const imgSrcs: Array<string> = [];
  for (let i in imagesArray) {
    imgSrcs.push(imagesArray[i]["src"]);
  }
  const openImageViewer = useCallback((index: number) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };
  return (
    <Stack
      sx={{
        width: "90vw",
        pl: { xs: 0, md: paddingLeft },
        backgroundColor: color,
      }}
      alignItems={"flex-start"}
      justifyContent={"center"}
    >
      {title && title?.length > 0 ? (
        <Title title={title === "undefined" ? "" : title} />
      ) : (
        ""
      )}

      <Grid
        container
        sx={{
          width: { xs: "90vw", md: "90vw" },
          margin: { xs: "auto", md: 0 },
        }}
        columns={{ xs: 1, sm: 3, md: 4 }}
        spacing={2}
      >
        {imagesArray.map((item, i) => (
          <Grid
            item
            xs={1}
            key={item.src + i}
            sx={{ cursor: "pointer" }}
            onClick={() => {
              openImageViewer(i);
            }}
          >
            <img
              width="100%"
              src={`${item.src}`}
              alt={item.title}
              loading="lazy"
            />
            <Typography>{item.title}</Typography>
          </Grid>
        ))}
        <>
          {isViewerOpen && (
            <ImageViewer
              src={imgSrcs}
              currentIndex={currentImage}
              disableScroll={false}
              closeOnClickOutside={true}
              onClose={closeImageViewer}
            />
          )}
        </>
      </Grid>
    </Stack>
  );
};

export default ImgGallery;
